/* eslint-disable */
import { ReactComponent as Svg } from "../media/images/home_image_1.svg";
import "../media/css/svg_anim.css";

export default function LandingSVG() {
  return (
      <Svg />
  )
}